import _inherits from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import throttle from 'lodash/throttle';

var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);

    this.calcOrientation();
    this.initListener();
  }

  _createClass(Base, [{
    key: "calcOrientation",
    value: function calcOrientation() {}
  }, {
    key: "addListener",
    value: function addListener() {}
  }, {
    key: "onChange",
    value: function onChange(handler) {
      this._onchange = handler;
    }
  }, {
    key: "fireChange",
    value: function fireChange() {
      if (typeof this._onchange === 'function') {
        this._onchange(this.orientation);
      }
    }
  }]);

  return Base;
}();

var Orientation = /*#__PURE__*/function (_Base) {
  _inherits(Orientation, _Base);

  var _super = _createSuper(Orientation);

  function Orientation() {
    _classCallCheck(this, Orientation);

    return _super.apply(this, arguments);
  }

  _createClass(Orientation, [{
    key: "calcOrientation",
    value: function calcOrientation() {
      this.orientation = window.orientation === 0 || window.orientation === 180 ? 'portrait' : 'landscape';
    }
  }, {
    key: "initListener",
    value: function initListener() {
      var _this = this;

      window.addEventListener('orientationchange', function (e) {
        _this.calcOrientation();

        _this.fireChange();
      });
    }
  }]);

  return Orientation;
}(Base);

var MediaOrientation = /*#__PURE__*/function (_Base2) {
  _inherits(MediaOrientation, _Base2);

  var _super2 = _createSuper(MediaOrientation);

  function MediaOrientation() {
    _classCallCheck(this, MediaOrientation);

    return _super2.apply(this, arguments);
  }

  _createClass(MediaOrientation, [{
    key: "calcOrientation",
    value: function calcOrientation() {
      this.orientation = this.getMedia().matches ? 'portrait' : 'landscape';
    }
  }, {
    key: "getMedia",
    value: function getMedia() {
      if (!this.media) {
        this.media = window.matchMedia('(orientation: portrait)');
      }

      return this.media;
    }
  }, {
    key: "initListener",
    value: function initListener() {
      var _this2 = this;

      this.getMedia().addListener(function (e) {
        _this2.calcOrientation();

        _this2.fireChange();
      });
    }
  }]);

  return MediaOrientation;
}(Base);

var ResizeOrientation = /*#__PURE__*/function (_Base3) {
  _inherits(ResizeOrientation, _Base3);

  var _super3 = _createSuper(ResizeOrientation);

  function ResizeOrientation() {
    _classCallCheck(this, ResizeOrientation);

    return _super3.apply(this, arguments);
  }

  _createClass(ResizeOrientation, [{
    key: "calcOrientation",
    value: function calcOrientation() {
      this.orientation = window.screen.width < window.screen.height ? 'portrait' : 'landscape';
    }
  }, {
    key: "initListener",
    value: function initListener() {
      var _this3 = this;

      window.addEventListener('resize', throttle(function () {
        var oldOrientation = _this3.orientation;

        _this3.calcOrientation();

        if (oldOrientation !== _this3.orientation) {
          _this3.fireChange();
        }
      }, 50));
    }
  }]);

  return ResizeOrientation;
}(Base);

export function create() {
  if (window.hasOwnProperty('orientation')) {
    console.info('[Orientation.create]orientation mode');
    return new Orientation();
  }

  if (window.matchMedia) {
    console.info('[Orientation.create]matchMedia mode');
    return new MediaOrientation();
  }

  console.info('[Orientation.create]resize mode');
  return new ResizeOrientation();
}